import Vue from 'vue/dist/vue'
// import App from './App.vue'
// import Service from './components/Service.vue'

Vue.config.productionTip = false

Vue.component('productdivision', require('./components/ProductDivision.vue').default)

new Vue({ el: '#app' })

// new Vue({
//   // render: h => h(App),
//     components: {
//         // 'service': Service
//     }
// }).$mount('#app')
